<template>
  <section
    class="component-welcome"
    resmed-component-name="component-welcome"
    v-bind:style="{ background: layout['background'] }"
  >
    <div class="component container px-xs-sm-2">
      <div class="row">
        <div
          class="
            col-md-11
            offset-md-1
            col-lg-12
            offset-lg-0
            col-xl-10
            offset-xl-1
          "
        >
          <div class="wrapper">
            <div class="welcome-question mb-2">
              <span v-html="introduction"></span>
            </div>

            <div class="topics">
              <h1 style="display: none">{{ h1 }}</h1>
              <h2>
                <!-- xs sm -->
                <span class="d-block d-md-none fade-in">I want to</span>
                <span class="d-block d-md-none fade-in">learn about</span>

                <!-- md lg xl -->
                <span class="d-none d-md-block fade-in">I want to learn</span>
                <span class="d-none d-md-inline-block about fade-in"
                  >about</span
                >

                <span class="mask">
                  <span
                    class="wrapper"
                    v-bind:class="{ [`step-${i}`]: true, complete: complete }"
                  >
                    <span v-for="item in animation" class="topic">{{
                      item.title
                    }}</span>
                  </span>
                </span>
              </h2>
              <div
                v-if="complete"
                v-on:click.prevent="
                  navigation.card.active = !navigation.card.active
                "
                class="call-to-action"
              >
                <a href="#" class="btn navigation-icon down-caret ripple"></a>
              </div>
              <p class="scroll-to-explore d-md-none">Or scroll to explore</p>
            </div>

            <navigation-card
              v-if="navigation.card.active"
              v-bind:items="items"
              v-bind:active.sync="navigation.card.active"
            >
            </navigation-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import navigationCard from "./navigation-card";

export default {
  name: "learn-about",
  components: {
    navigationCard,
  },
  props: ["h1", "introduction", "animation", "layout", "items"],
  data() {
    return {
      active: false,
      i: 1, // step value
      complete: false,
      navigation: {
        card: {
          active: false,
        },
      },
    };
  },
  created() {
    setTimeout(() => {
      this.active = true;
    }, 500);

    bus.$on("app.mounted", () => {
      setTimeout(() => {
        let interval = setInterval(() => {
          this.i += 1;

          if (this.i === this.animation.length) {
            clearInterval(interval);
            this.complete = true;
          }
        }, 1400);
      }, 3000);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-welcome {
  min-height: 90vh;
  padding: 120px 0 0 0;
  background-image: $cc-resmed-blue-deep-linear-gradient;

  @media (orientation: landscape) {
    min-height: 160vh;
  }

  @media (min-width: 768px) {
    min-height: 700px;
    padding: 200px 0 0 0;
  }

  @media (min-width: 992px) {
    min-height: 790px;
    padding: 250px 0 0 0;
  }
}

[class*="col"] > .wrapper {
  @media (min-width: 992px) {
    padding: 0 0 0 3rem;
  }

  @media (min-width: 1200px) {
    padding: 0;
  }
}

.welcome-question {
  text-align: center;
  opacity: 0;

  animation: fade-in 2s, slide-left 1s;
  animation-fill-mode: forwards;

  span {
    @extend %body-normal-bold;
    color: $cc-resmed-white;
    display: block;
  }

  @media (min-width: 768px) {
    text-align: left;
  }
}

.wrapper,
.mask {
  display: block;

  @media (min-width: 768px) {
    display: inline-block;
  }
}

.fade-in {
  opacity: 0;

  animation: fade-in 1.5s ease;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
}

.topics {
  position: relative;
  opacity: 0;

  animation: fade-in 0.75s ease-out, slide-left 0.5s ease-out;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;

  .topic {
    display: block;

    opacity: 0;
    animation: fade-in 0.75s ease;
    animation-delay: 2.8s;
    animation-fill-mode: forwards;

    @media (max-width: 575px) {
      height: 42px;
      overflow: hidden;
    }
  }

  .scroll-to-explore {
    @extend %body-normal-bold;
    text-align: center;
    color: $cc-resmed-white;
    padding-top: 3rem;
  }

  h2 {
    @extend %display;
    line-height: 1.1; // overwrite: keep 1.1 on all @media sizes
    text-align: center;

    @media (min-width: 768px) {
      text-align: left;
    }

    // exception
    // overwrite _headings.scss
    @media (min-width: 992px) {
      font-size: 5.063em;
      transform: translateX(-5px);
    }

    margin: 0;
    color: rgba($cc-resmed-white, 0.875);

    span {
      &:nth-child(1) {
        display: block;
      }
    }
  }
}

.about {
  @media (min-width: 768px) {
    transform: translateY(-8px);
  }

  @media (min-width: 992px) {
    transform: translateY(-26px);
  }
}

.mask {
  width: 100%;
  height: 42px;
  overflow: hidden;
  transform: translateY(2px);

  @media (min-width: 576px) {
    height: 55px;
  }

  @media (min-width: 768px) {
    transform: translateX(0);
    width: 490px;
  }

  @media (min-width: 992px) {
    transform: translateY(-9px);
    width: 640px;
    height: 89px;
  }

  @media (min-width: 1200px) {
    width: 700px;
  }

  .wrapper {
    transition: transform 0.5s ease-out;

    // steps 1-10
    $value: 0;
    @for $i from 1 through 10 {
      &.step-#{$i} {
        transform: translateY(-#{$value}px);

        @media (max-width: 575px) {
          &.complete {
            transform: translate(-0.8125rem, -#{$value}px);
          }
        }
      }
      $value: $value + 42;
    }

    @media (min-width: 576px) {
      $value: 0;
      @for $i from 1 through 10 {
        &.step-#{$i} {
          transform: translateY(-#{$value}px);

          @media (max-width: 767px) {
            &.complete {
              transform: translate(-0.8125rem, -#{$value}px);
            }
          }
        }
        $value: $value + 55;
      }
    }

    @media (min-width: 992px) {
      $value: 0;
      @for $i from 1 through 10 {
        &.step-#{$i} {
          transform: translateY(-#{$value}px);
        }
        $value: $value + 89;
      }
    }

    @media (min-width: 768px) and (max-width: 991) {
      transform: translateX(1rem);
    }

    // complete
    &.complete {
      opacity: 0.5;
      transition: opacity 1s ease-in, transform 0.5s ease-out;
    }
  }
}

.call-to-action {
  border-bottom: 2px dashed rgba($cc-resmed-white, 0.5);
  animation: fade-in 1.25s ease-in;
  position: absolute;
  cursor: pointer;

  width: 243px;
  height: 60px;
  top: 78px;
  left: calc(50% - 112px);

  @media (min-width: 576px) {
    transform: none;
    width: 310px;
    height: 60px;
    top: 115px;
    left: 93px;
  }

  @media (min-width: 768px) {
    width: 306px;
    height: 100px;
    top: 21px;
    left: 140px;
  }

  @media (min-width: 992px) {
    width: 492px;
    height: 100px;
    top: 80px;
    left: 220px;
  }

  .btn {
    position: absolute;
    right: 0;
    top: 12px;
    transform: scale(0.85);

    @media (min-width: 576px) {
      top: 8px;
      transform: scale(0.925);
    }

    @media (min-width: 768px) {
      transform: scale(1);
      top: 45px;
    }

    @media (min-width: 992px) {
      top: 28px;
      width: 3rem;
      height: 3rem;
      background-size: 1.63rem 1.63rem;
    }

    &.ripple {
      &:before {
        content: "";
        top: 0;
        left: 0;

        width: 2.25rem;
        height: 2.25rem;
        position: absolute;
        border-radius: 50%;
        border: 1px solid $cc-resmed-white;

        animation: ripple 2.5s ease-out;
        animation-iteration-count: 4444;
        animation-fill-mode: forwards;

        @media (min-width: 992px) {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }
}

@keyframes ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  60% {
    transform: scale(1.625, 1.625);
    opacity: 0;
  } // fake delay between iterations
  100% {
    transform: scale(1.625, 1.625);
    opacity: 0;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(40px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slide-left {
  0% {
    transform: translateX(80px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>